<template>
    <v-dialog v-model="dialog" persistent transition="scale-transition" max-width="500px">
        <v-card class="elevation-1">
            <ValidationObserver ref="refFormCancelar" v-slot="{ invalid, validated }">
                <v-form name="form" @submit.prevent="confirmar" lazy-validation>
                    <v-toolbar dark color="red darken-2">
                        <v-btn icon dark @click.native="handleModal">
                            <v-icon>fas fa-times-circle</v-icon>
                        </v-btn>
                        <v-toolbar-title>Cancelar abono</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn class="white--text" text type="submit" :disabled="invalid || !validated" :loading="loading">
                                <v-icon class="ma-2" dense large left>fas fa-check</v-icon>Confirmar
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <p>Estas por cancelar el abono de <strong>{{ formatNumberToMoney(abonoSelected.monto) }}</strong>.</p>
                                <p class="red--text">Se revertira el monto al saldo pendiente de la deduccion. No se puede revertir.</p>
                            </v-col>
                            <v-col cols="12">
                                <ValidationProvider rules="required" v-slot="{ errors, valid}">
                                    <v-autocomplete :items="motivos" item-text="name" item-value="id"
                                    v-model="catCancellationReasonId" label="Motivo de cancelacion*" required
                                    prepend-icon="fas fa-comment-slash"
                                    :error-messages="errors" :success="valid">
                                    </v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <small>* Indica son campos requeridos</small>
                    </v-card-text>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
import AbonoDeduccionDataService from '@/service/deduccion/AbonoDeduccionDataService';
import CancellationReasonDataService from '@/service/catalogo/cancellationReason/cancellationReasonDataService';
import { getFormatCurrency } from '@/utils/CurrencyUtil';

export default {
    name: "CancelarAbono",
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        initialize: { type: Function },
        abonoSelected: { type: Object, default: () => ({}) }
    },
    created() {
        this.getMotivos();
    },
    data() {
        return {
            loading: false,
            motivos: [],
            catCancellationReasonId: null
        }
    },
    methods: {
        async getMotivos() {
            this.motivos = await CancellationReasonDataService.byModule('DEDUCTION_PAYMENT').then(resp => resp.data) || [];
        },
        formatNumberToMoney(number) {
            return getFormatCurrency(parseFloat(number) || 0, "$");
        },
        confirmar() {
            this.$refs.refFormCancelar.validate().then(isValid => {
                if (!isValid) return;
                this.loading = true;
                AbonoDeduccionDataService.cancel(this.abonoSelected.id, this.catCancellationReasonId).then(() => {
                    this.handleModal();
                    this.initialize();
                    this.$swal.fire({ icon: 'success', title: 'Abono cancelado', showConfirmButton: false, timer: 1500 });
                }).catch(err => {
                    this.$swal.fire({ icon: 'error', title: 'Error al cancelar el abono', text: err.response?.data, showConfirmButton: false, timer: 3000 });
                }).finally(() => this.loading = false);
            });
        }
    }
}
</script>
